import React, {useEffect, useState} from "react";

function CustomInput({className, onChange, initValue, type,style = {},key,disabled}) {

    const [value, setValue] = useState(initValue)

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        setTimeout(() => {
            onChange(value)
            // Send Axios request here
        }, 500)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    return (
        <input
            className={className}
            type={type}
            style={style}
            value={value}
            key={key}
            onChange={(e) => setValue(e.target.value)}
        />
    );
}

export default CustomInput;
